var state = {

	pageTotal:0,//分页数据中的资源总数
	// 模块分类
	top_nav:[
		{
			text:'一课一空间',
			url:"/teaching/jiaoxue",
			title1:'独享文件',
			title2:'授课便捷'
		},
		{
			text:'作业管理',
			// url:"",
			url:"/teaching/zuoye",
			title1:'简单易用',
			title2:'个性催交'
		},
		{
			text:'考试管理',
			// url:"",
			url:"/teaching/exam",
			title1:'线上阅卷',
			title2:'邀请合作'
		}
	],

	resources: [],//资源列表数组


	error_text: "",

	//年级科目班级筛选节点
	chapterid:0,
	selectlabel:'',


	// restype:'kongjian',
	newtype:'all',
	subnavs : [
		{
			text:'全部',
			restype:'all'
		},
		{
			text:'课件',
			restype:'schkejian'
		},
		{
			text:'教案',
			restype:'schjiaoan'
		},
		{
			text:'习题',
			restype: 'schxiti'
		},
		{
			text:'微课',
			restype: 'schweike'
		},
		{
			text:'其他',
			restype: 'schqita'
		},
	],

	//筛选方式
	// selectnavs:[
	// 	{
	// 		text:'最新上传',
	// 		id:'0'
	// 	},
	// 	{
	// 		text:'最多下载',
	// 		id:'1'
	// 	},
	// ],
	// //默认筛选方式为最新上传
	// selectnavid:'0',
	//默认筛选方式为时间排序
	selectnavid:'0',
	sort:'2',

	trees: [],
	tree_info: [],//第一章第一小节
  jie:'',
  tree_infos:[],//小节id
	left_lists:[{
		text:'第一单元',
		children:[{
			text:'字母',
		},{
			text:'拼音',
		},{
			text:'字母',
		},{
			text:'拼音',
		},]
	},{
		text:'第二单元',
		children:[{
			text:'字母',
		},{
			text:'拼音',
		},]
	},{
		text:'第三单元',
		children:[{
			text:'字母',
		},{
			text:'拼音',
		},]
	},],

	//教学空间资源详情仓库
	jiaoxueinfo:{},
	isloading:'loading',

	//教材信息
	bookinfo:[],
	bookPageTotal:0,
	bookClassid:0,

	footer_show:'show',

	jiaoxueIsload:'yes',//教学页是否需要加载,yes表示需要加载,no表示不需要
	submenuIsload:'yes',//年级科目分类是否需要加载

	//时间轴信息仓库
	timeline:[],

  // 作业管理
  userid:'',//用户小程序userid
  statusScreen:['全部','未开始','进行中','已完成'],//列表状态
  statusActive:'全部',
  statusidnex:'0',
  schoolArry:'',//用户学校
  zuoyepage:1,
  zuoyepagesize:7,
  zuoyelist:'',//作业列表数据
  zuoyetotal:'',//作业总条数
  zuoyesort:'2',//1 最小到最大， 2重最大到最小
  // 查看作业
  taskid:'',//查看当前作业下班级情况
  zuoyeSee:'',//当前作业班级下情况

  zuoyeSeepage:1,//
  zuoyeSeepagesize:7,//
  zuoyeSeetotle:'',
  // 作业统计
  zuoyestatic:'',//作业统计列表
  staticsort:'2',

  	//考试管理
	examStatus:'0',
    examlistStatus: [
		{text:'全部', examStatus: '0'},
		{text:'未开始', examStatus: '1'},
		{text:'进行中', examStatus: '2'},
		{text:'已结束', examStatus: '3'},
		{text:'已阅卷', examStatus: '4'},
	],
	selectclassids: '',
	kaoshitotal:'',//考试总条数
	kaoshipage:1,
	kaoshipagesize:7,	
	startimeExamSort:1,
	kaoshilist:[],//考试列表数据
}
export default	state



// WEBPACK FOOTER //
// ./src/store/modules/teaching/state.js